import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SimpleSolverComponent } from '@examdojo/solver';
import { SimpleLayoutConfig, SimpleSolverBlock, SolverSlide } from '../../../model';

@Component({
  selector: 'dojo-simple-solver-block-renderer',
  template: `<dojo-simple-solver [slide]="slide()" [config]="config()" />`,
  styles: `
    :host {
      @apply block my-4;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SimpleSolverComponent],
})
export class SimpleSolverBlockRendererComponent {
  readonly block = input.required<SimpleSolverBlock>();

  readonly slide = computed<SolverSlide>(() => {
    const block = this.block();
    return {
      name: block.name,
      steps: block.steps,
      initial_super_latex_content: block.initial_super_latex_content,
      initial_description_content: block.initial_description_content,
    };
  });

  readonly config = computed<SimpleLayoutConfig>(() => {
    const block = this.block();
    return {
      width: block.width,
      latex_on_right: block.latex_on_right,
    };
  });
}
